var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapper",attrs:{"id":"main"}},[_c('top-navigation'),_vm._v(" "),_c('sidebar'),_vm._v(" "),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }